export const ACCEPTED_COUNTRY_NAMES = [
  "Kuwait",
  "State of Kuwait",
  "Dawlat al-Kuwait",
  "Palau",
  "Republic of Palau",
  "Beluu er a Belau",
  "Liechtenstein",
  "Principality of Liechtenstein",
  "Fürstentum Liechtenstein",
  "Moldova",
  "Moldova, Republic of",
  "Republic of Moldova",
  "Republica Moldova",
  "Angola",
  "República de Angola",
  "ʁɛpublika de an'ɡɔla",
  "Bolivia",
  "Buliwya",
  "Wuliwya",
  "Bolivia, Plurinational State of",
  "Plurinational State of Bolivia",
  "Estado Plurinacional de Bolivia",
  "Buliwya Mamallaqta",
  "Wuliwya Suyu",
  "Tetã Volívia",
  "Tuvalu",
  "Peru",
  "Republic of Peru",
  "República del Perú",
  "Germany",
  "Federal Republic of Germany",
  "Bundesrepublik Deutschland",
  "Botswana",
  "Republic of Botswana",
  "Lefatshe la Botswana",
  "Afghanistan",
  "Afġānistān",
  "Hungary",
  "Burkina Faso",
  "Canada",
  "Indonesia",
  "Republic of Indonesia",
  "Republik Indonesia",
  "Taiwan",
  "Táiwān",
  "Republic of China",
  "中華民國",
  "Zhōnghuá Mínguó",
  "Chinese Taipei",
  "Saint Lucia",
  "St. Lucia",
  "Gabon",
  "Gabonese Republic",
  "République Gabonaise",
  "Liberia",
  "Republic of Liberia",
  "Turkey",
  "Turkiye",
  "Republic of Turkey",
  "Türkiye Cumhuriyeti",
  "Mali",
  "Republic of Mali",
  "République du Mali",
  "Benin",
  "Republic of Benin",
  "République du Bénin",
  "Cyprus",
  "Kýpros",
  "Kıbrıs",
  "Republic of Cyprus",
  "Κυπριακή Δημοκρατία",
  "Kıbrıs Cumhuriyeti",
  "Somalia",
  "aṣ-Ṣūmāl",
  "Federal Republic of Somalia",
  "Jamhuuriyadda Federaalka Soomaaliya",
  "Jumhūriyyat aṣ-Ṣūmāl al-Fiderāliyya",
  "Niger",
  "Nijar",
  "Portugal",
  "Portuguesa",
  "Portuguese Republic",
  "República Portuguesa",
  "Senegal",
  "Republic of Senegal",
  "République du Sénégal",
  "Cuba",
  "Republic of Cuba",
  "República de Cuba",
  "Belarus",
  "Bielaruś",
  "Republic of Belarus",
  "Белоруссия",
  "Республика Белоруссия",
  "Barbados",
  "Tunisia",
  "Republic of Tunisia",
  "al-Jumhūriyyah at-Tūnisiyyah",
  "Israel",
  "State of Israel",
  "Medīnat Yisrā'el",
  "Italy",
  "Italian Republic",
  "Repubblica italiana",
  "Myanmar",
  "Burma",
  "Republic of the Union of Myanmar",
  "Pyidaunzu Thanmăda Myăma Nainngandaw",
  "Burma",
  "Micronesia",
  "Federated States of Micronesia",
  "Micronesia, Federated States of",
  "Djibouti",
  "Jabuuti",
  "Gabuuti",
  "Republic of Djibouti",
  "République de Djibouti",
  "Gabuutih Ummuuno",
  "Jamhuuriyadda Jabuuti",
  "Republic of the Congo",
  "Congo",
  "Congo-Brazzaville",
  "Congo",
  "Republic of Congo",
  "DR Congo",
  "DR Congo",
  "Congo-Kinshasa",
  "Congo, the Democratic Republic of the",
  "DRC",
  "Congo",
  "DRC",
  "Democratic Republic of  Congo",
  "Belize",
  "Australia",
  "Cameroon",
  "Republic of Cameroon",
  "République du Cameroun",
  "Russia",
  "Russian Federation",
  "Российская Федерация",
  "Antigua and Barbuda",
  "Antigua",
  "Antigua Barbuda",
  "Japan",
  "Nippon",
  "Nihon",
  "Honduras",
  "Republic of Honduras",
  "República de Honduras",
  "Burundi",
  "Republic of Burundi",
  "Republika y'Uburundi",
  "République du Burundi",
  "Paraguay",
  "Republic of Paraguay",
  "República del Paraguay",
  "Tetã Paraguái",
  "Argentina",
  "Argentine Republic",
  "República Argentina",
  "São Tomé and Príncipe",
  "Democratic Republic of São Tomé and Príncipe",
  "Sao Tome and Principe",
  "República Democrática de São Tomé e Príncipe",
  "Sao Tome",
  "Lesotho",
  "Kingdom of Lesotho",
  "Muso oa Lesotho",
  "Sudan",
  "Republic of the Sudan",
  "Jumhūrīyat as-Sūdān",
  "El Salvador",
  "Republic of El Salvador",
  "República de El Salvador",
  "Kyrgyzstan",
  "Киргизия",
  "Kyrgyz Republic",
  "Кыргыз Республикасы",
  "Kyrgyz Respublikasy",
  "Brazil",
  "Brasil",
  "Federative Republic of Brazil",
  "República Federativa do Brasil",
  "Brasil",
  "Cambodia",
  "Kingdom of Cambodia",
  "South Africa",
  "RSA",
  "Suid-Afrika",
  "Republic of South Africa",
  "Guatemala",
  "United States",
  "USA",
  "United States of America",
  "USA",
  "United States",
  "The United States Of America",
  "Azerbaijan",
  "Republic of Azerbaijan",
  "Azərbaycan Respublikası",
  "Malaysia",
  "Colombia",
  "Republic of Colombia",
  "República de Colombia",
  "Mauritania",
  "Islamic Republic of Mauritania",
  "al-Jumhūriyyah al-ʾIslāmiyyah al-Mūrītāniyyah",
  "Bahrain",
  "Kingdom of Bahrain",
  "Mamlakat al-Baḥrayn",
  "Belgium",
  "België",
  "Belgie",
  "Belgien",
  "Belgique",
  "Kingdom of Belgium",
  "Koninkrijk België",
  "Royaume de Belgique",
  "Königreich Belgien",
  "Chile",
  "Republic of Chile",
  "República de Chile",
  "North Macedonia",
  "The former Yugoslav Republic of Macedonia",
  "Republic of North Macedonia",
  "Macedonia, The Former Yugoslav Republic of",
  "Република Северна Македонија",
  "Macedonia",
  "Mozambique",
  "Republic of Mozambique",
  "República de Moçambique",
  "Ethiopia",
  "ʾĪtyōṗṗyā",
  "Federal Democratic Republic of Ethiopia",
  "የኢትዮጵያ ፌዴራላዊ ዲሞክራሲያዊ ሪፐብሊክ",
  "India",
  "Bhārat",
  "Republic of India",
  "Bharat Ganrajya",
  "இந்தியா",
  "Spain",
  "Kingdom of Spain",
  "Reino de España",
  "Kazakhstan",
  "Qazaqstan",
  "Казахстан",
  "Republic of Kazakhstan",
  "Қазақстан Республикасы",
  "Qazaqstan Respublïkası",
  "Республика Казахстан",
  "Respublika Kazakhstan",
  "Oman",
  "Sultanate of Oman",
  "Salṭanat ʻUmān",
  "United Arab Emirates",
  "UAE",
  "Emirates",
  "UAE",
  "Poland",
  "Republic of Poland",
  "Rzeczpospolita Polska",
  "Grenada",
  "Sri Lanka",
  "ilaṅkai",
  "Democratic Socialist Republic of Sri Lanka",
  "Tajikistan",
  "Toçikiston",
  "Republic of Tajikistan",
  "Ҷумҳурии Тоҷикистон",
  "Çumhuriyi Toçikiston",
  "Syria",
  "Syrian Arab Republic",
  "Al-Jumhūrīyah Al-ʻArabīyah As-Sūrīyah",
  "Libya",
  "State of Libya",
  "Dawlat Libya",
  "Haiti",
  "Republic of Haiti",
  "République d'Haïti",
  "Repiblik Ayiti",
  "San Marino",
  "Republic of San Marino",
  "Repubblica di San Marino",
  "Tonga",
  "Georgia",
  "Sakartvelo",
  "Eritrea",
  "State of Eritrea",
  "ሃገረ ኤርትራ",
  "Dawlat Iritriyá",
  "ʾErtrā",
  "Iritriyā",
  "Tanzania",
  "Tanzania, United Republic of",
  "United Republic of Tanzania",
  "Jamhuri ya Muungano wa Tanzania",
  "Czechia",
  "Česká republika",
  "Česko",
  "Czechia",
  "Kosovo",
  "Република Косово",
  "Bhutan",
  "Kingdom of Bhutan",
  "Egypt",
  "Arab Republic of Egypt",
  "Saint Kitts and Nevis",
  "Federation of Saint Christopher and Nevis",
  "Saint Kitts",
  "St. Kitts",
  "St. Kitts and Nevis",
  "Vietnam",
  "Socialist Republic of Vietnam",
  "Cộng hòa Xã hội chủ nghĩa Việt Nam",
  "Viet Nam",
  "Marshall Islands",
  "Republic of the Marshall Islands",
  "Aolepān Aorōkin M̧ajeļ",
  "Austria",
  "Osterreich",
  "Oesterreich",
  "Papua New Guinea",
  "Independent State of Papua New Guinea",
  "Independen Stet bilong Papua Niugini",
  "Bahamas",
  "Commonwealth of the Bahamas",
  "The Bahamas",
  "Croatia",
  "Hrvatska",
  "Republic of Croatia",
  "Republika Hrvatska",
  "Slovenia",
  "Republic of Slovenia",
  "Republika Slovenija",
  "Uzbekistan",
  "Republic of Uzbekistan",
  "O‘zbekiston Respublikasi",
  "Ўзбекистон Республикаси",
  "Finland",
  "Suomi",
  "Republic of Finland",
  "Suomen tasavalta",
  "Republiken Finland",
  "Guyana",
  "Co-operative Republic of Guyana",
  "Monaco",
  "Principality of Monaco",
  "Principauté de Monaco",
  "Slovakia",
  "Slovak Republic",
  "Slovenská republika",
  "Yemen",
  "Yemeni Republic",
  "al-Jumhūriyyah al-Yamaniyyah",
  "Malawi",
  "Republic of Malawi",
  "Gambia",
  "Republic of the Gambia",
  "The Gambia",
  "Panama",
  "Republic of Panama",
  "República de Panamá",
  "Ireland",
  "Éire",
  "Republic of Ireland",
  "Poblacht na hÉireann",
  "South Korea",
  "Korea, Republic of",
  "Republic of Korea",
  "남한",
  "남조선",
  "Republic of Korea",
  "Korea",
  "Greece",
  "Elláda",
  "Hellenic Republic",
  "Ελληνική Δημοκρατία",
  "Pakistan",
  "Pākistān",
  "Islamic Republic of Pakistan",
  "Islāmī Jumhūriya'eh Pākistān",
  "Armenia",
  "Hayastan",
  "Republic of Armenia",
  "Հայաստանի Հանրապետություն",
  "Malta",
  "Republic of Malta",
  "Repubblika ta' Malta",
  "Turkmenistan",
  "Dominican Republic",
  "Solomon Islands",
  "Vanuatu",
  "Republic of Vanuatu",
  "Ripablik blong Vanuatu",
  "République de Vanuatu",
  "Madagascar",
  "Republic of Madagascar",
  "Repoblikan'i Madagasikara",
  "République de Madagascar",
  "Laos",
  "Lao",
  "Lao People's Democratic Republic",
  "Sathalanalat Paxathipatai Paxaxon Lao",
  "Mongolia",
  "France",
  "French Republic",
  "République française",
  "Central African Republic",
  "Central African Republic",
  "République centrafricaine",
  "Eswatini",
  "Swaziland",
  "weSwatini",
  "Swatini",
  "Ngwane",
  "Kingdom of Eswatini",
  "Umbuso weSwatini",
  "Swaziland",
  "United Kingdom",
  "UK",
  "Great Britain",
  "UK",
  "Iceland",
  "Island",
  "Republic of Iceland",
  "Lýðveldið Ísland",
  "Nepal",
  "Federal Democratic Republic of Nepal",
  "Loktāntrik Ganatantra Nepāl",
  "Ghana",
  "Iraq",
  "Republic of Iraq",
  "Jumhūriyyat al-‘Irāq",
  "Thailand",
  "Prathet",
  "Thai",
  "Kingdom of Thailand",
  "ราชอาณาจักรไทย",
  "Ratcha Anachak Thai",
  "Denmark",
  "Danmark",
  "Kingdom of Denmark",
  "Kongeriget Danmark",
  "Serbia",
  "Srbija",
  "Republic of Serbia",
  "Република Србија",
  "Republika Srbija",
  "Uganda",
  "Republic of Uganda",
  "Jamhuri ya Uganda",
  "Montenegro",
  "Crna Gora",
  "Saudi Arabia",
  "SA",
  "Kingdom of Saudi Arabia",
  "Al-Mamlakah al-‘Arabiyyah as-Su‘ūdiyyah",
  "Jordan",
  "Hashemite Kingdom of Jordan",
  "al-Mamlakah al-Urdunīyah al-Hāshimīyah",
  "Suriname",
  "Sarnam",
  "Sranangron",
  "Republic of Suriname",
  "Republiek Suriname",
  "New Zealand",
  "Aotearoa",
  "Kenya",
  "Republic of Kenya",
  "Jamhuri ya Kenya",
  "Mexico",
  "Mexicanos",
  "United Mexican States",
  "Estados Unidos Mexicanos",
  "Bosnia and Herzegovina",
  "Bosnia-Herzegovina",
  "Босна и Херцеговина",
  "Bosnia",
  "Bosnia Herzegovina",
  "Saint Vincent and the Grenadines",
  "Saint Vincent",
  "St. Vincent",
  "Seychelles",
  "Republic of Seychelles",
  "Repiblik Sesel",
  "République des Seychelles",
  "The Seychelles",
  "Bulgaria",
  "Republic of Bulgaria",
  "Република България",
  "Latvia",
  "Republic of Latvia",
  "Latvijas Republika",
  "Guinea",
  "Republic of Guinea",
  "République de Guinée",
  "Lebanon",
  "Lebanese Republic",
  "Al-Jumhūrīyah Al-Libnānīyah",
  "Luxembourg",
  "Grand Duchy of Luxembourg",
  "Grand-Duché de Luxembourg",
  "Großherzogtum Luxemburg",
  "Groussherzogtum Lëtzebuerg",
  "Mauritius",
  "Republic of Mauritius",
  "République de Maurice",
  "Estonia",
  "Eesti",
  "Republic of Estonia",
  "Eesti Vabariik",
  "Norway",
  "Norge",
  "Noreg",
  "Kingdom of Norway",
  "Kongeriket Norge",
  "Kongeriket Noreg",
  "Comoros",
  "Union of the Comoros",
  "Union des Comores",
  "Udzima wa Komori",
  "al-Ittiḥād al-Qumurī",
  "Venezuela",
  "Bolivarian Republic of Venezuela",
  "Venezuela, Bolivarian Republic of",
  "República Bolivariana de Venezuela",
  "Iran",
  "Islamic Republic of Iran",
  "Iran, Islamic Republic of",
  "Jomhuri-ye Eslāmi-ye Irān",
  "Sweden",
  "Kingdom of Sweden",
  "Konungariket Sverige",
  "Fiji",
  "Viti",
  "Republic of Fiji",
  "Matanitu ko Viti",
  "Fijī Gaṇarājya",
  "Philippines",
  "Republic of the Philippines",
  "Repúblika ng Pilipinas",
  "The Philippines",
  "Uruguay",
  "Oriental Republic of Uruguay",
  "República Oriental del Uruguay",
  "Switzerland",
  "Swiss Confederation",
  "Schweiz",
  "Suisse",
  "Svizzera",
  "Svizra",
  "Trinidad and Tobago",
  "Republic of Trinidad and Tobago",
  "Trinidad",
  "Rwanda",
  "Republic of Rwanda",
  "Repubulika y'u Rwanda",
  "République du Rwanda",
  "Albania",
  "Shqipëri",
  "Shqipëria",
  "Shqipnia",
  "Guinea-Bissau",
  "Republic of Guinea-Bissau",
  "República da Guiné-Bissau",
  "Guinea-Bissau",
  "Ivory Coast",
  "Côte d'Ivoire",
  "Ivory Coast",
  "Republic of Côte d'Ivoire",
  "République de Côte d'Ivoire",
  "Cote D'Ivoire",
  "Cote Divoire",
  "Côte d'Ivoire",
  "North Korea",
  "Democratic People's Republic of Korea",
  "DPRK",
  "조선민주주의인민공화국",
  "Chosŏn Minjujuŭi Inmin Konghwaguk",
  "Korea, Democratic People's Republic of",
  "북한",
  "북조선",
  "Democratic People's Republic of Korea",
  "Andorra",
  "Principality of Andorra",
  "Principat d'Andorra",
  "Maldives",
  "Maldive Islands",
  "Republic of the Maldives",
  "Dhivehi Raajjeyge Jumhooriyya",
  "Nauru",
  "Naoero",
  "Pleasant Island",
  "Republic of Nauru",
  "Ripublik Naoero",
  "Singapore",
  "Singapura",
  "Republik Singapura",
  "新加坡共和国",
  "Zimbabwe",
  "Republic of Zimbabwe",
  "Dominica",
  "Dominique",
  "Wai‘tu kubuli",
  "Commonwealth of Dominica",
  "Morocco",
  "Kingdom of Morocco",
  "Al-Mamlakah al-Maġribiyah",
  "Qatar",
  "State of Qatar",
  "Dawlat Qaṭar",
  "Costa Rica",
  "Republic of Costa Rica",
  "República de Costa Rica",
  "Cape Verde",
  "Republic of Cabo Verde",
  "República de Cabo Verde",
  "Cabo Verde",
  "Netherlands",
  "Holland",
  "Nederland",
  "The Netherlands",
  "The Netherlands",
  "Romania",
  "Rumania",
  "Roumania",
  "România",
  "Sierra Leone",
  "Republic of Sierra Leone",
  "Nicaragua",
  "Republic of Nicaragua",
  "República de Nicaragua",
  "Algeria",
  "Dzayer",
  "Algérie",
  "Jamaica",
  "Togo",
  "Togolese",
  "Togolese Republic",
  "République Togolaise",
  "Vatican City",
  "Holy See (Vatican City State)",
  "Vatican City State",
  "Stato della Città del Vaticano",
  "Vatican",
  "Ecuador",
  "Republic of Ecuador",
  "República del Ecuador",
  "Samoa",
  "Independent State of Samoa",
  "Malo Saʻoloto Tutoʻatasi o Sāmoa",
  "Nigeria",
  "Nijeriya",
  "Naíjíríà",
  "Federal Republic of Nigeria",
  "Zambia",
  "Republic of Zambia",
  "Chad",
  "Tchad",
  "Republic of Chad",
  "République du Tchad",
  "Lithuania",
  "Republic of Lithuania",
  "Lietuvos Respublika",
  "Ukraine",
  "Ukrayina",
  "China",
  "Zhōngguó",
  "Zhongguo",
  "Zhonghua",
  "People's Republic of China",
  "中华人民共和国",
  "Zhōnghuá Rénmín Gònghéguó",
  "People's Republic of China",
  "Palestine",
  "Palestine, State of",
  "State of Palestine",
  "Dawlat Filasṭin",
  "South Sudan",
  "Bangladesh",
  "People's Republic of Bangladesh",
  "Gônôprôjatôntri Bangladesh",
  "Equatorial Guinea",
  "Republic of Equatorial Guinea",
  "República de Guinea Ecuatorial",
  "République de Guinée équatoriale",
  "República da Guiné Equatorial",
  "Namibia",
  "Namibië",
  "Republic of Namibia",
  "Timor-Leste",
  "East Timor",
  "Democratic Republic of Timor-Leste",
  "República Democrática de Timor-Leste",
  "Repúblika Demokrátika Timór-Leste",
  "Timór Lorosa'e",
  "Timor Lorosae",
  "East Timor",
  "Timor-Leste",
  "Brunei",
  "Brunei Darussalam",
  "Nation of Brunei",
  "the Abode of Peace",
  "Kiribati",
  "Republic of Kiribati",
  "Ribaberiki Kiribati",
];
